// extracted by mini-css-extract-plugin
export default {"searchByEmail":"UserSearch_searchByEmail__fC5b5","searchBar":"UserSearch_searchBar__gtlww","searchInput":"UserSearch_searchInput__-MQKI"};